/**
 * @generated SignedSource<<95fd0d1292725a387817a96be82fcf4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespCreatorsLayout_viewer$data = {
  readonly itemSearch: {
    readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsComponents_itemSearch" | "SbSharedHead_itemSearch" | "SbSharedRefetchContainer_itemSearch" | "useSbSharedPageTracking_itemSearch">;
  };
  readonly user?: {
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsComponents_user" | "useSbSharedPageTracking_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsComponents_viewer">;
  readonly " $fragmentType": "SbRespCreatorsLayout_viewer";
};
export type SbRespCreatorsLayout_viewer$key = {
  readonly " $data"?: SbRespCreatorsLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "disableForceFacet"
    },
    {
      "kind": "RootArgument",
      "name": "disableNonParameterizedUrlRedirects"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "guestId"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin"
    },
    {
      "kind": "RootArgument",
      "name": "originalUrl"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "personalizationId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "regions"
    },
    {
      "kind": "RootArgument",
      "name": "regionsList"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespCreatorsLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespCreatorsComponents_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useSbSharedPageTracking_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbRespCreatorsComponents_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "disableForceFacet",
            "variableName": "disableForceFacet"
          },
          {
            "kind": "Variable",
            "name": "disableNonParameterizedUrlRedirects",
            "variableName": "disableNonParameterizedUrlRedirects"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "guestId",
            "variableName": "guestId"
          },
          {
            "kind": "Variable",
            "name": "localeOrigin",
            "variableName": "localeOrigin"
          },
          {
            "kind": "Variable",
            "name": "originalUrl",
            "variableName": "originalUrl"
          },
          {
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
          },
          {
            "kind": "Variable",
            "name": "priceBookName",
            "variableName": "priceBookName"
          },
          {
            "kind": "Variable",
            "name": "regions",
            "variableName": "regions"
          },
          {
            "kind": "Variable",
            "name": "regionsList",
            "variableName": "regionsList"
          },
          {
            "kind": "Variable",
            "name": "uriRef",
            "variableName": "uriRef"
          },
          {
            "kind": "Variable",
            "name": "userCountryCode",
            "variableName": "userCountryCode"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "personalizationId"
          }
        ],
        "concreteType": "ItemSearchQueryConnection",
        "kind": "LinkedField",
        "name": "itemSearch",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SbSharedHead_itemSearch"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SbRespCreatorsComponents_itemSearch"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SbSharedRefetchContainer_itemSearch"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useSbSharedPageTracking_itemSearch"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "39005f5902307c14b57c91265ff7bb73";

export default node;
